import React from 'react';
import ReactPlayer from 'react-player';
import './YoutubePlayer.css';

const YoutubePlayer = ({ videoId }) => {
  const embedUrl = `https://www.youtube.com/watch?v=${videoId}`;

  return (
      <div className="youtube-player" >
        <div className="youtube-player__video">
          <ReactPlayer
              className="youtube-player__player"
              url={embedUrl}
              width="100%"
              height="100%"
              controls
          />
        </div>
      </div>
  );
};

export default YoutubePlayer;